export interface GovernanceBlock {
  readonly name: string;
  readonly determinant: number;
  readonly conditionNumber: number;
  readonly fragility: "ROBUST" | "WATCH";
  readonly singularityMeaning: string;
}

export interface GovernanceHealthSummary {
  readonly overallDeterminant: number;
  readonly worstBlock: GovernanceBlock;
}

export const GOVERNANCE_HEALTH_BLOCKS: readonly GovernanceBlock[] = [
  {
    name: "Authority (G1)",
    determinant: 4.0,
    conditionNumber: 1.0,
    fragility: "ROBUST",
    singularityMeaning: "Irreversible privilege grant",
  },
  {
    name: "Knowledge (G2)",
    determinant: 2.5,
    conditionNumber: 3.0,
    fragility: "ROBUST",
    singularityMeaning: "Trust domain collapse",
  },
  {
    name: "Temporal (G3)",
    determinant: 2.0,
    conditionNumber: 2.0,
    fragility: "ROBUST",
    singularityMeaning: "Temporal deadlock",
  },
  {
    name: "Resource (G4)",
    determinant: 2.7,
    conditionNumber: 1.8,
    fragility: "ROBUST",
    singularityMeaning: "Unresolvable resource obligation",
  },
];

export function summarizeGovernanceHealth(
  blocks: readonly GovernanceBlock[],
): GovernanceHealthSummary {
  return {
    overallDeterminant: blocks.reduce((product, block) => product * block.determinant, 1),
    worstBlock: blocks.reduce((worst, block) =>
      worst.conditionNumber > block.conditionNumber ? worst : block,
    ),
  };
}

export function determinantMarginPercent(block: GovernanceBlock): number {
  return Math.min((Math.abs(block.determinant) / 5) * 100, 100);
}
